import { useDispatch, useSelector } from "react-redux";
import { useState, useEffect } from "react";
import { getInfo } from "../slice/workerInfoSlice";

const WorkerVerify = () => {
    const dispatch = useDispatch();
    const token = localStorage.getItem("token");

    const { userData, loading } = useSelector(
        (state) => state.workerInfo
      );
    
      useEffect(() => {
        if (!token) return;
    
        dispatch(getInfo(token));
      }, [token, dispatch]);

       if (loading || !userData) {
    return (
      <div className="col-md-4 col-xl-3 sidebar">
        <p className="text-muted">Loading menu...</p>
      </div>
    );
  }

  const { id, role_id, first_name, last_name } = userData;

    const navigateToEzverifi = () => {
        const client_id = process.env.REACT_APP_EZVERIFI_CLIENT_ID;
        const secret_key = process.env.REACT_APP_EZVERIFI_SECRET_KEY;
        const user_type = role_id;
        // const user_type = 5;
        // const user_id = localStorage.getItem("user_id");
        const user_id = id;
        // const user_id = 12;

        // Optional: Use real user names if available
        // const firstName = provider.contact_name;
        // const lastName = provider.contact_name1;

        // const firstName = "Ellinas";
        // const lastName = "Georgios";

        const baseUrl = `https://portal.ezverifi.com/rest/apiverification/`;
        const url = `${baseUrl}?client_id=${client_id}&secret_key=${secret_key}&user_type=${user_type}&id=${user_id}&firstname=${first_name}&lastname=${last_name}`;

        // console.log("url", url);

        window.open(url, "_blank");
    };

    return (
        <>
            <div className="col-md-8 col-xl-9 mt-4 mt-md-0">
                <div className="ps-2 ps-lg-4">
                    <h4 className="font-weight-bold text-primary font-size-40 mb-4 pb-1 line-hight-2 border-bottom pb-3 montserrat">
                        Verification
                    </h4>

                    <div className="form-section mt-3 d-flex justify-content-center">
                        <button className="btn btn-custom-primary w-50" onClick={navigateToEzverifi}>Verify with ezverifi</button>
                    </div>
                </div>
            </div>
        </>
    );
};
export default WorkerVerify;